<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item v-if="this.user.user.roles[0].id == 1" :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('p15')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <div class="searchright">
                        <el-button size="small" type="primary" @click="openadd">+{{$t('p16')}}</el-button>
                    </div>
                    <div class="top"></div>
                    <el-table :data="list" :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                        <el-table-column prop="tempId" :label="$t('p17')"></el-table-column>
                        <el-table-column prop="type" :label="$t('p18')">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.type == 1" type="info">Código de verificación</el-tag>
                                <el-tag v-if="scope.row.type == 2" type="info">0-2 días antes del atraso</el-tag>
                                <el-tag v-if="scope.row.type == 3" type="info">Atrasado por 1-7 días</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="content" :label="$t('p19')"></el-table-column>
                        <!-- <el-table-column prop="time" :label="$t('p20')"></el-table-column> -->
                        <el-table-column prop="date1" :label="$t('kssj')"></el-table-column>
                        <el-table-column prop="date2" :label="$t('jssj')"></el-table-column>
                        <el-table-column prop="level" :label="$t('createTime')">
                            <template slot-scope="scope">
                                {{scope.row.createTime|changedate}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="jobName" :label="$t('operator')" width="150">
                            <template slot-scope="scope">
                                <el-button size="small" @click="openedit(scope.row)" type="primary" icon="el-icon-edit"
                                    circle plain style="margin-right:5px;"></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <pop-up :title="status == 1? $t('p16') : $t('p21')" :isshow="showadd" :haveconfirm="true" 
            @close="getclose" @confirm="getconfirm">
            <div slot="box" style="width: 500px;">
                <el-form ref="form" :inline="true" :model="form" :rules="rules" size="small">
                    <el-form-item :label="$t('p22')">
                        <el-select v-model="form.type" :placeholder="$t('qxz')">
                            <el-option label="Código de verificación" value="1"></el-option>
                            <el-option label="0-2 días antes del atraso" value="2"></el-option>
                            <el-option label="Atrasado por 1-7 días" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('kssj')">
                        <el-col :span="20">
                            <el-date-picker type="date" :placeholder="$t('xzTime')" v-model="form.date1" 
                                style="width: 100%;" value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-col>
                    </el-form-item>
                    <el-form-item :label="$t('jssj')">
                        <el-col :span="20">
                            <el-date-picker type="date" :placeholder="$t('xzTime')" v-model="form.date2" 
                                style="width: 100%;" value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-col>
                    </el-form-item>
                    <!-- <el-form-item :label="$t('p23')" prop="time">
                        <el-input v-model="form.time"/>
                    </el-form-item> -->
                    <el-form-item :label="$t('p24')" prop="content" >
                        <el-input type="textarea" :rows="4" v-model="form.content"/>
                    </el-form-item>
                </el-form>
            </div>
        </pop-up>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {
        LOAD_CHILDREN_OPTIONS
    } from '@riophae/vue-treeselect'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                form: {
                    id: null,
                    type: null,
                    content: null,
                    time: null,
                    date1: null,
                    date2: null,
                },
                rules: {
                    content:[
                        { required: true, message: this.$t('pleaseClassifyName'), trigger: 'blur' }
                    ],
                    type:[
                        { required: true, message: this.$t('pleaseClassifyName'), trigger: 'blur' }
                    ],
                },
                defaultProps: {
                    label: "name",
                    isLeaf: 'isLeaf'
                },
                loading: false,
                showadd: false,
                list: [],
                value1:[],
            }
        },
        created() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            this.getList()
        },
        methods: {
            openadd() {
                this.showadd = true
                this.status = 1
                this.form = {
                    id: null,
                    type: null,
                    content: null,
                    time: null,
                    date1: null,
                    date2: null,
                }
            },
            openedit(row) {
                this.status = 2
                this.form.id = row.id
                this.form.tempId = row.tempId
                this.form.type = row.type
                this.form.content = row.content
                this.form.time = row.time
                this.form.createTime = row.createTime
                this.form.date1 = row.date1
                this.form.date2 = row.date2
                this.showadd = true
            },
            getclose() {
                this.$refs.form.resetFields();
                this.showadd = false
            },
            handleNodeClick(mydata, node, obj) {
                this.loading = true
                this.getList()
            },
            getconfirm() {
                if (this.status == 1) { //如果是添加
                    _api.post(apiurl.plantilla, this.form)
                    .then(res => {
                        this.$notify.success({
                            title: this.$t('success'),
                            message: this.$t('addSuccess')
                        })
                        this.getList()
                        this.showadd = false
                        this.form = {
                            id: null,
                            type: null,
                            content: null,
                            time: null,
                            date1: null,
                            date2: null,
                        }

                    }).catch(err => {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: err.data.message
                        })
                    })
                } else { //如果是编辑
                    _api.put(apiurl.plantilla, this.form)
                    .then(res => {
                        this.$notify.success({
                            title: this.$t('success'),
                            message: this.$t('editSuccess')
                        })
                        this.getList()
                        this.showadd = false
                        this.form = {
                            id: null,
                            type: null,
                            content: null,
                            time: null,
                            date1: null,
                            date2: null,
                        }
                    }).catch(err => {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: err.data.message
                        })
                    })
                }
            },
            getList() {
                this.loading = true
                _api.get(apiurl.plantilla, {
                }).then(res => {
                    this.loading = false
                    this.list = res.data
                })
            },
            onSubmit() {
                this.getList()
            },
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .top {
        margin-top: 15px;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>